<med-navigation-loading><ng-container *ngTemplateOutlet="routeroutlet"></ng-container> </med-navigation-loading>
<ng-template #routeroutlet>
    <router-outlet></router-outlet>
</ng-template>

<med-toasts-container></med-toasts-container>
